import type { MouseEvent } from 'react';
import { useState } from 'react';
import { Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';

const FILTER_BUTTON_SX = {
  borderColor: '#d0d7e2',
  borderRadius: 2,
  textTransform: 'none' as const,
  color: '#1f2a37',
  minWidth: 220,
  justifyContent: 'space-between',
  px: 2,
  py: 1.5,
};

type Props = {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (value: string) => void;
};

export default function RouletteContentSubFilter({
  label,
  value,
  options,
  onChange,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (opt: string) => {
    onChange(opt);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={FILTER_BUTTON_SX}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <EmojiObjectsOutlinedIcon fontSize="small" />
          <Stack direction="column" alignItems="flex-start">
            <Typography variant="caption" sx={{ color: '#6b7280', fontSize: 12 }}>
              {label}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {value}
            </Typography>
          </Stack>
        </Stack>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt}
            selected={opt === value}
            onClick={() => handleSelect(opt)}
          >
            {opt}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
